<template>
  <BreadCrumb PageTitle="Nouvelle Facture" />
  <NewInvoice />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import NewInvoice from "@/components/Invoices/NewInvoice.vue";

export default defineComponent({
  name: "NewInvoicePage",
  components: {
    BreadCrumb,
    NewInvoice,
  },
});
</script>